/* eslint-disable jsx-a11y/media-has-caption */
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import Text from '../../../../assets/styles/Text';
import CustomMidia from '../../../../components/CustomMidia';
import Loader from '../../../../components/Loader';
import Title from '../../../../components/Title';
import { useModelMediasInfinite } from '../../../../hooks/queries/useMediaUploads';
import * as styles from './styles';

export default function Uploads() {
  const [selectedType, setSelectedType] = useState(null);
  const { id } = useParams();

  // Hook para infinite query
  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useModelMediasInfinite(id, selectedType);

  // Flatten pages em um único array
  const uploads = useMemo(
    () => data?.pages?.flatMap((page) => page.urls) || [],
    [data]
  );

  function handleSelected(type) {
    setSelectedType((prev) => (prev === type ? null : type));
  }

  async function handleLoadMore() {
    if (hasNextPage && !isFetchingNextPage) {
      await fetchNextPage();
    }
  }

  return (
    <styles.Container id="media">
      <Title title="GALERIA DE MÍDIAS" small />

      <styles.GroupButton $selected={selectedType}>
        <button type="button" onClick={() => handleSelected('photo')}>
          <Text.Span $bold>Fotos</Text.Span>
        </button>
        <button type="button" onClick={() => handleSelected('video')}>
          <Text.Span $bold>Vídeos</Text.Span>
        </button>
      </styles.GroupButton>

      {isLoading ? (
        <Loader isLoading minimal />
      ) : (
        <>
          <styles.GroupUpload>
            {uploads?.map((upload, index) => (
              <CustomMidia
                key={upload.id}
                midia={upload}
                index={index}
                isImg={upload.mediaType === 'photo'}
                total={uploads.length}
              />
            ))}
          </styles.GroupUpload>

          {hasNextPage && (
            <styles.GroupButton>
              <button
                type="button"
                onClick={handleLoadMore}
                disabled={isFetchingNextPage}
              >
                {isFetchingNextPage ? (
                  <Text.Span>Carregando...</Text.Span>
                ) : (
                  <Text.Span $bold>Ver mais</Text.Span>
                )}
              </button>
            </styles.GroupButton>
          )}
        </>
      )}
    </styles.Container>
  );
}
